<div class="row no-gutters">
  <ngb-datepicker (dateSelect)="onDateSelect($event)" [(ngModel)]="selectedDate" [minDate]="minDate" [maxDate]="maxDate" [startDate]="selectedDate"></ngb-datepicker>
</div>
<div class="row no-gutters">
  <button class="btn btn-sm btn-outline-primary m-2" (click)="selectToday()" title="Sélectionner la date du jour">Aujourd'hui</button>
  <button class="btn btn-sm btn-outline-primary m-2" (click)="selectNoDate()" title="Supprimer la date">Supprimer</button>
</div>
